import { StyledIframe } from '../components/iframe';
import { createLegacyUrl } from '../utils/legacy';
import { UnicornApi } from '@cld/unicorn-api';

export const UsageReports = ({ unicornApi }: { unicornApi: UnicornApi }) => {
  const { productEnvironment } = unicornApi.data;

  return <StyledIframe src={createLegacyUrl('', productEnvironment.externalId)} title="Ruby developer dashboard" />;
};
